import React, { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';
import { Container } from "./style";
export var QRCode = function QRCode(_ref) {
  var url = _ref.url,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 500 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 500 : _ref$height,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#000' : _ref$color,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '#fff' : _ref$bgColor,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'png' : _ref$type,
    image = _ref.image,
    _ref$imageSize = _ref.imageSize,
    imageSize = _ref$imageSize === void 0 ? 1.0 : _ref$imageSize,
    _ref$imageMargin = _ref.imageMargin,
    imageMargin = _ref$imageMargin === void 0 ? 0 : _ref$imageMargin,
    _ref$errorCorrectionL = _ref.errorCorrectionLevel,
    errorCorrectionLevel = _ref$errorCorrectionL === void 0 ? 'L' : _ref$errorCorrectionL,
    download = _ref.download;
  var qrDiv = useRef();
  useEffect(function () {
    qrCode.update({
      data: url
    });
    if (download) {
      qrCode.download({
        name: 'qr-code',
        extension: type
      });
    }
  }, [url, download]);
  useEffect(function () {
    qrCode.append(qrDiv.current);
  }, []);
  var qrCode = new QRCodeStyling({
    width: width,
    height: height,
    type: 'svg',
    image: image,
    dotsOptions: {
      color: color,
      type: 'rounded'
    },
    imageOptions: {
      crossOrigin: 'anonymous',
      imageSize: imageSize,
      margin: imageMargin
    },
    cornersSquareOptions: {
      type: 'extra-rounded'
    },
    qrOptions: {
      errorCorrectionLevel: errorCorrectionLevel
    },
    backgroundOptions: {
      color: bgColor
    }
  });
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    "aria-label": "qrcode-graphic",
    ref: qrDiv
  }));
};